<div class="multi-select-chips-field">
  <div class="multi-select-chips-field__content">
    <mat-chip-grid #chipGrid [attr.aria-label]="ariaLabel">
      @for (item of selected(); track item.id) {
        <mat-chip-row [disabled]="disabled" (removed)="remove(item)">
          {{ item.desc }}
          <button
            matChipRemove
            [attr.aria-label]="'Remove ' + item.desc"
            [matTooltip]="'Remove ' + item.desc"
            [disabled]="disabled"
          >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      #chipsInput
      [attr.aria-label]="ariaLabel"
      [attr.placeholder]="placeholder"
      [value]="currentDesc()"
      [disabled]="disabled"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="chipsAuto"
      #chipsAutoTrigger="matAutocompleteTrigger"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (input)="onInput($event)"
      (matChipInputTokenEnd)="addChip()"
    />
    <mat-autocomplete #chipsAuto="matAutocomplete" (optionSelected)="autocompleteSelected($event)">
      @for (item of filteredDescriptors(); track item.id) {
        <mat-option [value]="item" (click)="$event.stopPropagation(); chipsAutoTrigger.openPanel();">
          {{ item.desc }}
        </mat-option>
      }
    </mat-autocomplete>
  </div>
  <div class="multi-select-chips-field__suffix" matSuffix>
    <button
      class="multi-select-chips-field__suffix-button"
      mat-icon-button
      type="button"
      (click)="$event.stopPropagation(); addAllFiltered(); clearCurrent(); chipsAutoTrigger.openPanel();"
      matTooltip="Add All"
      [attr.aria-label]="'Add All'"
      [disabled]="disabled"
    >
      <!-- keeping autocomplete panel open, see https://stackoverflow.com/a/57117207 -->
      <mat-icon>add_box</mat-icon>
    </button>
    @if (hasSelected()) {
      <button
        class="multi-select-chips-field__suffix-button"
        mat-icon-button
        type="button"
        (click)="clearAll()"
        matTooltip="Clear"
        [attr.aria-label]="'Clear'"
        [disabled]="disabled"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
</div>
